import {NgModule} from "@angular/core";
import {UserNotificationsComponent} from "./user-notifications.component";
import {AppSharedModule} from "../../app-shared/app-shared.module";
import {CartDetailModule} from "../../cart/cart-detail/cart-detail.module";
import {CartWidgetFooterModule} from "../../cart/cart-widget-footer/cart-widget-footer.module";
import {FieldSelectInputModule} from "../../app-shared";
import {NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {SortByBooleanPipeModule} from "../../app-shared/pipes/sort-by-boolean/sort-by-boolean.pipe.module";
import {SortPipeModule} from "../../app-shared/pipes/sort-pipe/sort.pipe.module";
import {TranslateModule} from "@ngx-translate/core";
import {MatExpansionModule} from "@angular/material/expansion";

@NgModule({
  declarations: [UserNotificationsComponent],
  imports: [
    AppSharedModule,
    CartDetailModule,
    CartWidgetFooterModule,
    FieldSelectInputModule,
    NgForOf,
    NgIf,
    RouterLink,
    SortByBooleanPipeModule,
    SortPipeModule,
    TranslateModule,
    MatExpansionModule
  ],
  exports: [UserNotificationsComponent]
})
export class UserNotificationModule {}
